<template>
  <div class="overflow-hidden p-2">
    <b-row class="my-2">
      <b-col cols="4">
        <b-row v-if="getContinuousFilingTask.data != null">
          <b-col cols="12">
            <b-row>
              <b-col cols="12">
                <table class="min-w-full leading-normal mt-1 text-gray" style="border: solid 1px #dedede;">
                  <thead>
                  <tr class="bg-gray-pale">
                    <td colspan="12" class="px-2 py-2 font-bold">Attachments</td>
                  </tr>
                  <tr>
                    <th class="px-2 py-1">#</th>
                    <th class="px-2 py-1">File Name</th>
                    <th class="px-2 py-1 float-end">Action</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(file, idx) in getContinuousFilingTask.data.attachments" :key="idx" style="border: solid 1px #dedede;">
                    <td class="px-2 py-1">{{idx + 1}}</td>
                    <td class="px-2 py-1 text-capitalize">{{cleanName(file.purpose)}}</td>
                    <td class="px-2 py-1">
                      <button class="float-end bg-gray rounded text-white hover:bg-gray-dark px-2" @click="openFile(file)">Show</button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              <div class="mt-3">
                <AmalgamationContinuousFilingFiles :draftData="getContinuousFilingTask" v-on:url="openFile"></AmalgamationContinuousFilingFiles>
              </div>
              </b-col>
            </b-row>
          </b-col>

        </b-row>
      </b-col>
      <b-col cols="8">
        <ContinuousFilingAttachments ref="attachmentScreen" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ContinuousFilingAttachments from "@/views/home/services/continuous-filing/task/ContinuousFilingAttachments";
import moment from "moment/moment";
import server from "@/app/env/server.json";
import AmalgamationContinuousFilingFiles
  from "@/views/home/services/continuous-filing/task/AmalgamationContinuousFilingFiles.vue";

export default {
  name: "ContinuousFilingFiles",
  components: {AmalgamationContinuousFilingFiles, ContinuousFilingAttachments },
  data(){
    return{
      attachmentUrl:null,
      draft:null
    }
  },
  mounted() {
    this.openFile(this.getContinuousFilingTask.data.attachments[0])
  },
  methods:{
    dateFormat(date){
      return moment(date).format("DD-MM-YYYY")
    },
    openFile(data){
      let fName = data ? data.attachment.trim() : ""
      this.attachmentUrl = server.IP+"/incorporation/companies/downloads?attachment="+fName
    },
    cleanName(name){
      let n = name.replaceAll("_", " ")
      return n.toLowerCase()
    },
  },
  computed:{
    ...mapGetters(
        [
            "getContinuousFilingTask"
        ]
    ),
  },
  watch:{
    attachmentUrl:{
      handler(url){
        this.$refs.attachmentScreen.openFile(url)
      },
      deep:true
    },
    getContinuousFilingTask(data){
      if(data){
        this.draft = data
      }
    }
  }
}
</script>

<style scoped>
th, td{
  font-size: 12px;
}
</style>